export default __webpack_public_path__ + "static/media/pressure.523a9463.png";